/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams, Link, useNavigate, useLoaderData } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser';
//todo head: config, searchApi.getProductItem,
import slugify from '../../utils/slugify';
import sortSizes from '../../utils/sortSizes';
import uniqBy from '../../utils/uniqBy';

import { ReactComponent as ArrowDownIcon } from '../../images/icons/arrowDown.svg';
import { ReactComponent as WishListIcon } from '../../images/icons/wishlist_transparent.svg';
import { ReactComponent as WishListSelectedIcon } from '../../images/icons/wishlist.svg';
import { ReactComponent as ShopListMobile } from '../../images/icons/shop-list-mobile.svg';
import { ReactComponent as AdultContent } from '../../images/icons/erotics.svg';

import styles from './ProductDetailPage.module.scss';
import getCDNImage from '../../utils/getCDNImage';
import useMediaQuery from '../../utils/useMediaQuery';
import loadable from '@loadable/component';

import { contentApi, getValidResponseBody, productApi } from '../../api';
import loadVisibleComponent from '../../utils/loadVisibleComponent';
import { clipTextEllipsis } from '../../utils/textEllipsis';
import Button, { SECONDARY } from '../Button/Button';
import ProductOffers from '../ProductOffers/ProductOffers';
import { getPagePath } from '../../utils/appRoutes';
import { useAuth0Wrapper } from '../../utils/auth0';
import useWishlist from '../../utils/useWishlist';
import SimilarProductsSection from '../SimilarProductsSection';
import { ARD_CATEGORY_SEARCH, ARD_SEARCH } from '../../utils/appRoutes.definitions';
import useRecentlyViewedActions from '../../utils/useRecentlyViewedActions';
import RelatedCategories from '../RelatedCategories';
import useAdultContentHandlers from '../../utils/useAdultContentHandlers';
import ReviewStats from '../ReviewStats/ReviewStats';

const NoContent = loadable(() => import('./NoContent'));
const ProductSchema = loadable(() => import('../ProductSchema'));
const PropertyCarousel = loadable(() => import('../PropertyCarousel/PropertyCarousel'));
const PropertyColor = loadable(() => import('../PropertyColor/PropertyColor'));
const PropertySize = loadable(() => import('../PropertySize/PropertySize'));
const Breadcrumb = loadable(() => import('../Breadcrumb/Breadcrumb'));
const Gallery = loadable(() => import('../Gallery'));
const AdultContentModal = loadable(() => import('../AdultContentModal'));
// const PricesChart = loadVisibleComponent(() => import('../PricesChart/PricesChart'));

const StickyHeader = loadable(() => import('../StickyHeader/StickyHeader'));

const ReviewsComponent = loadable(() => import('Features/reviews/ReviewsComponent'));
const RecentlyViewedProducts = loadVisibleComponent(() => import('../RecentlyViewedProducts/RecentlyViewedProducts'));
const LoginModal = loadVisibleComponent(() => import('../LoginModal/LoginModal'));
const Footer = loadVisibleComponent(() => import('../Footer/Footer'));
const NewsletterSection = loadVisibleComponent(() => import('../NewsletterSection/NewsletterSection'));

const ProductDetailPage = ({ config, clickout, profile }) => {
  const { productInfo, shopOffersBody, similarProducts, hasPriceChecker } = useLoaderData();
  const intl = useIntl();
  const { productId } = useParams();
  const navigate = useNavigate();
  const { isGreaterOrEqualTo, isLowerThan, BREAKPOINTS } = useMediaQuery();
  const shareContainer = useRef(null);
  const shareContainerDesktop = useRef(null);
  const [imageGallery, setImageGallery] = useState(null);
  const [activeShopsSortOrder, setActiveShopSortOrder] = useState({
    key: 'skip',
    direction: null,
  });
  const [size, setSize] = useState(null);
  const [activeAccordionItem, setActiveAccoridionItem] = useState(null);
  const [openShare, setOpenShare] = useState(false);
  const [openShareDesktop, setOpenShareDesktop] = useState(false);
  const [shopInfoData, setShopInfoData] = useState(false);
  const [visible, setVisible] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [disableMobileButton, setDisableMobileButton] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openOverlay, setOpenOverlay] = useState(false);
  const accordionCont = useRef(null);
  const description = useRef(null);
  const productMoreInfo = useRef(null);
  const buttonMobile = useRef(null);
  const productInformation = useRef(null);
  const productDescription = useRef(null);
  const descriptionHeader = useRef(null);
  const pricesHeaderRef = useRef(null);
  const specificationsHeader = useRef(null);
  const informationHeader = useRef(null);
  const [merchantPid, setMerchantPid] = useState(null);
  const [sizeSelectionRequired, setSizeSelectionRequired] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);
  const { toggleWishlistItem, isWishlistItem } = useWishlist();
  const { saveRecentlyViewedProductToProfile, saveRecentlyViewedProductAnonymously } = useRecentlyViewedActions();
  const descriptionContainer = useRef(null);
  const [openReadMore, setOpenReadMore] = useState(false);
  const [hasReadMore, setHasReadMore] = useState(false);
  const { adultContentAllowed } = useAdultContentHandlers();
  const { isAuthenticated } = useAuth0Wrapper();

  const showOverlay = () => setOpenOverlay(true);

  const productReviews = productInfo?.reviews;

  const { tokenClaims } = useAuth0Wrapper();
  const authToken = tokenClaims?.__raw;

  //Use react router data loaders
  // const { data: reviewsFLData, setData: setReviewsData } = useFrontload('product-detail-page-reviews', async () => {
  //   return { productReviewsData: null };
  // });

  useEffect(() => {
    if (!isAuthenticated) {
      saveRecentlyViewedProductAnonymously(productId);
    } else {
      saveRecentlyViewedProductToProfile(productId, profile);
    }
  }, [productId, isAuthenticated, profile?.recentlyViewedProducts?.length]);

  const addReviewRequest = useCallback(
    async (formElements, rating) => {
      const payload = {
        productId,
        ean: productInfo?.offers?.[0]?.EAN,
        rating,
        title: formElements.title.value.trim(),
        text: formElements.content.value.trim(),
      };
      let submitResp = null;
      try {
        const resp = await productApi.addReview({
          body: JSON.stringify(payload),
          method: 'POST',
          headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
        });
        submitResp = resp;
      } catch (err) {
        console.error(err);
        submitResp = { ok: false };
      }

      return submitResp;
    },
    [productId, productInfo?.offers, authToken]
  );
  // useEffect(() => {
  //   (async () => {
  //     const EAN = productInfo?.offers?.[0]?.EAN;
  //     const productReviewsData = await reviewsApi.getProductReviews(productId, EAN);
  //     setReviewsData((data) => ({ ...data, productReviewsData }));
  //   })();
  // }, [productInfo?.id]);

  const isExpiredProduct = !!productInfo?.expiredProduct;

  useEffect(() => {
    if (!openReadMore) {
      const hasReadMore = descriptionContainer?.current?.offsetHeight < descriptionContainer?.current?.scrollHeight;
      setHasReadMore(hasReadMore);
    }
  }, [openReadMore, productInfo]);

  useEffect(() => {
    if (openReadMore) {
      setOpenReadMore(false);
    }
  }, [productInfo]);

  const toggleContent = () => {
    setOpenReadMore(true);
  };

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    if (currentScrollPos > 0) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (isLowerThan(BREAKPOINTS.MEDIUM)) window.addEventListener('scroll', handleScroll);
    else window.removeEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const showPage = () => {
    if (isLowerThan(BREAKPOINTS.MEDIUM)) setVisible(true);
    setDisableMobileButton(true);
  };

  useEffect(() => {
    if (!pricesHeaderRef?.current) return;
    if (disableMobileButton) {
      window.scrollTo({
        top: pricesHeaderRef.current.offsetTop - 70,
        behavior: 'smooth',
      });
    }
    setDisableMobileButton(false);
  }, [disableMobileButton]);

  useEffect(() => {
    if (readMore) {
      window.scrollTo({
        top: productMoreInfo.current.offsetTop - 100,
        behavior: 'smooth',
      });
    }

    setReadMore(false);
  }, [readMore]);

  const scrollToElement = (element) => {
    window.scrollTo({
      top: element.offsetTop - 100,
      behavior: 'smooth',
    });
  };

  const moveToProductMoreInfo = () => {
    setVisible(true);
    setReadMore(true);
  };

  useEffect(() => {
    if (buttonMobile.current && pricesHeaderRef.current) {
      const viewPortButtonMobile = buttonMobile.current.offsetTop;
      const viewPortshopsList = pricesHeaderRef.current.offsetTop;
      if (viewPortButtonMobile + 10 > viewPortshopsList) setVisible(true);
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (productInfo?.shop_id && !hasPriceChecker) {
        const shopInfoData = await contentApi.getShopInfo(productInfo?.shop_id);
        const shopInfo = getValidResponseBody(shopInfoData);
        setShopInfoData(shopInfo);
      }
      const preSelectedSpecsItem = productInfo?.specs?.features.find((feature) => feature.expanded);
      if (preSelectedSpecsItem) setActiveAccoridionItem(preSelectedSpecsItem.group);
    })();
  }, [productInfo, hasPriceChecker]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (shareContainer.current && !shareContainer.current.contains(e.target) && openShare) {
        setOpenShare(false);
      }

      if (shareContainerDesktop.current && !shareContainerDesktop.current.contains(e.target) && openShareDesktop) {
        setOpenShareDesktop(false);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openShare, openShareDesktop]);

  const setExistingMerchantPid = (value) => {
    if (value) setMerchantPid(value);
  };

  const pickFirstItemMerchantPid = (offers) => {
    setExistingMerchantPid(offers[0]?.merchant_product_id);
    setOutOfStock(parseInt(offers?.[0]?.stock_count) === 0);
  };

  const pickDefaultMerchantPid = (offers) => {
    if (offers.length === 1) pickFirstItemMerchantPid(offers);

    const offersSizes = offers.filter(({ size }) => size?.[0]);
    const offersOthers = offers.filter(({ size }) => !size?.[0]);

    if (!offersSizes?.length && offersOthers?.length) pickFirstItemMerchantPid(offersOthers);
    if (offersSizes?.length && !offersOthers?.length) setSizeSelectionRequired(true);

    return null;
  };

  useEffect(() => {
    if (!merchantPid && productInfo?.offers) pickDefaultMerchantPid(productInfo.offers);
  }, [productInfo?.id, merchantPid]);

  const [likedProduct, setLikedProduct] = useState(false);

  useEffect(() => {
    const isLikedProduct = isWishlistItem(productId);

    setLikedProduct(isLikedProduct);
  }, [isWishlistItem, productId]);

  const handleWishlistBtnPress = () => {
    toggleWishlistItem(productId);
  };

  const { shops: shopOffers = [], aggregations: shopOffersAggregation } = shopOffersBody || {};

  const onMouseEnterColor = (color) => {
    setImageGallery(getCDNImage(color.images[0]));
  };

  const onMouseLeaveColor = () => {
    setImageGallery(null);
  };

  const onClickColor = (color) => {
    navigate(color.pdp_path);
  };

  const onClickSizes = (newSize) => {
    setSize(size === newSize ? null : newSize);
  };

  const availableSortOptions = {
    name: {
      key: 'name',
      initialDirection: 'asc',
      sort: (shops, direction) => {
        return shops.sort(function compare(firstShop, secondShop) {
          const nameA = firstShop.campaign.toUpperCase();
          const nameB = secondShop.campaign.toUpperCase();

          if (nameA < nameB) {
            return direction === 'asc' ? -1 : 1;
          }

          if (nameA > nameB) {
            return direction === 'asc' ? 1 : -1;
          }

          return 0;
        });
      },
    },

    delivery: {
      key: 'deliveryTime',
      disabled: true,
      sort: (shops) => shops,
    },

    skip: {
      key: 'skip',
      sort: (shops) => shops,
    },

    price: {
      key: 'price',
      initialDirection: 'asc',
      sort: (shops, direction) => {
        return shops.sort(function compare(firstShop, secondShop) {
          if (direction === 'asc') {
            if (firstShop.isFeatured && !secondShop.isFeatured) {
              return -1;
            }
            if (secondShop.isFeatured && !firstShop.isFeatured) {
              return 1;
            }
          }

          if (firstShop.price < secondShop.price) {
            return direction === 'asc' ? -1 : 1;
          }

          if (firstShop.price > secondShop.price) {
            return direction === 'asc' ? 1 : -1;
          }

          return secondShop.campaign.toUpperCase() - firstShop.campaign.toUpperCase();
        });
      },
    },
  };

  const getPropertyColorsFromProduct = (selectedValue) => {
    let components = [];
    let selectedIndex = 0;
    let colorSelected = null;
    const colors = shopOffersAggregation?.color_variants;

    if (colors?.length) {
      components = uniqBy(colors, 'pdp_path').map((col, index) => {
        const selected = col.pdp_path.includes(selectedValue); // product.id

        if (selected) {
          selectedIndex = index;
          colorSelected = col;
        }

        return (
          <PropertyColor
            key={`product-variant-${col.color}`}
            color={col}
            selected={selected}
            onClickColor={onClickColor}
            onMouseEnterColor={onMouseEnterColor}
            onMouseLeaveColor={onMouseLeaveColor}
          />
        );
      });
    }

    return {
      components,
      selectedIndex,
      colorSelected,
    };
  };

  const getPropertySizesFromProductClickout = (selectedValue) => {
    let components = [];
    let selectedIndex = 0;

    if (
      shopOffersAggregation &&
      shopOffersAggregation.nested.sizes &&
      shopOffersAggregation.nested.sizes.buckets.length > 0
    ) {
      const availableSizes = productOffers.reduce((total, shop) => {
        const offers = shop.offers.filter((item) => item.size !== null);
        offers.forEach((offer) => {
          total.push(offer.size);
        });
        return total;
      }, []);

      const sizesWithoutDuplicate = [...new Set(availableSizes.flat())];

      components = sortSizes(sizesWithoutDuplicate).map((size, index) => {
        //string item - represents the size itself
        const selected = size === selectedValue; // state.size
        if (selected) {
          selectedIndex = index;
        }
        return <PropertySize key={size} size={size} selected={selected} onClickSizes={onClickSizes} />;
      });
    }
    return {
      components,
      selectedIndex,
    };
  };

  //todo: extract size selector to a separate component
  const getPropertySizesFromProduct = getPropertySizesFromProductClickout;

  const changeSortOrder = (option) => {
    if (option.disabled) {
      return;
    }

    if (activeShopsSortOrder.key === option.key) {
      setActiveShopSortOrder({
        key: option.key,
        direction: activeShopsSortOrder.direction === 'asc' ? 'desc' : 'asc',
      });
    } else {
      setActiveShopSortOrder({
        key: option.key,
        direction: option.initialDirection,
      });
    }
  };

  const getSortedProductOffersList = () => {
    let shops = [
      {
        ...productInfo,
      },
    ];

    if (hasPriceChecker && shopOffers?.length) {
      //Get shops from /product-shops
      const activeShops = shopOffers.filter((shop) => {
        if (!size) {
          return true;
        }

        if (size && !shop.offers?.length) {
          return false;
        }
        return shop.offers.some((item) => item.size && item.size.includes(size));
      });
      if (isExpiredProduct) shops = [...shops, ...activeShops];
      else shops = activeShops;
    }

    const sort = availableSortOptions[activeShopsSortOrder.key].sort;
    return sort(shops, activeShopsSortOrder.direction);
  };

  const passImgUrlThrough = (url) => (...actions) => actions.reduce((prevUrl, action) => action(prevUrl), url);
  const removeSizeExtFromImgUrl = (url) => url.replace(/.[0-9]+x[0-9]+./, '.');

  const images = productInfo.images.map((image, index) => {
    return {
      //Those are the fields needed by react-image-gallery
      //imageGallery variable contains replacement images with selected product options
      original: imageGallery ? imageGallery : passImgUrlThrough(image)(getCDNImage),
      large: imageGallery ? imageGallery : passImgUrlThrough(image)(getCDNImage, removeSizeExtFromImgUrl),
      thumbnail: `${getCDNImage(productInfo?.thumbs?.[index] || image)}`,
      thumbnailLoading: 'lazy',
      originalAlt: productInfo.name,
      thumbnailAlt: productInfo.name + ' - thumbnail',
      originalTitle: productInfo.name,
      thumbnailTitle: productInfo.name + ' - thumbnail',
    };
  });

  const onToggle = (specGroupName, e) => {
    const stickyHeader = document.querySelector('#root > div > header');
    if (activeAccordionItem === specGroupName) {
      setActiveAccoridionItem(null);
    } else {
      const target = e.currentTarget;
      const stickyHeaderRect = stickyHeader?.getBoundingClientRect();
      const { height, top } = stickyHeaderRect;
      const offsetTopCompensation = height + top || 130;

      setTimeout(() => {
        window.scrollTo({
          top: target.offsetTop - offsetTopCompensation,
          behavior: 'smooth',
        });
      }, 300);

      setActiveAccoridionItem(specGroupName);
    }
  };
  const reasonsToBuy = productInfo?.specs?.reasonsToBuy;

  const reasonsToBuyLi = reasonsToBuy?.map((item, index) => {
    return (
      <li key={item.title + index}>
        <p>
          <b>{item.title}</b>
        </p>
        <p>{item.value}</p>
      </li>
    );
  });

  const reasonsToBuyEl = reasonsToBuy && <ul>{reasonsToBuyLi}</ul>;

  const accordionEl = productInfo?.specs?.features.map((feature, index) => {
    const activeItem = activeAccordionItem === feature.group;
    const items = feature?.items?.map((x, index) => (
      <div className={classNames({ [styles.active]: activeItem })} key={index}>
        <dl className={styles.productSpecs}>{x.name}</dl>
        <dl className={styles.productSpecs}>{x.value}</dl>
      </div>
    ));

    return (
      <dl className={styles.productDetails} key={index}>
        <dt
          onClick={(e) => onToggle(feature.group, e)}
          className={activeItem ? styles.productGroupActive : styles.productGroup}
        >
          {feature.group}
        </dt>
        {items}
      </dl>
    );
  });

  let height;
  if (description.current && description.current.clientHeight < 258) {
    height = 'auto';
  } else if (description.current && description.current.clientHeight > 258) {
    height = 258;
  }

  let styleProductDescription;
  let styleProductInformation;
  const minAllowableHeight = 400;

  const categoriesNames = [productInfo?.category, productInfo?.subcategory, productInfo?.subsubcategory].filter(
    Boolean
  );
  const categories = categoriesNames.map(slugify);
  const category = categories[0] || '';
  const subcategory = categories[1] || '';
  const subsubcategory = categories[2] || '';
  let breadcrumbList = [];

  if (productInfo.category) {
    breadcrumbList.push({
      url: getPagePath(ARD_CATEGORY_SEARCH, [category]),
      slug: productInfo.category,
      text: productInfo.category,
    });
  }

  if (productInfo.subcategory) {
    breadcrumbList.push({
      url: getPagePath(ARD_CATEGORY_SEARCH, [category, subcategory]),
      slug: productInfo.subcategory,
      text: productInfo.subcategory,
    });
  }

  if (productInfo.subsubcategory) {
    breadcrumbList.push({
      url: getPagePath(ARD_CATEGORY_SEARCH, [category, subcategory, subsubcategory]),
      slug: productInfo.subsubcategory,
      text: productInfo.subsubcategory,
    });
  }

  const quickList = [
    {
      label: intl.formatMessage({ id: 'shop.prices' }),
      value: pricesHeaderRef.current,
    },
  ];

  if (productInfo.description) {
    quickList.push({
      label: intl.formatMessage({ id: 'common.product_description' }),
      value: descriptionHeader?.current?.parentNode.parentNode.parentNode,
    });
  }

  if (productInformation.current) {
    quickList.push({
      label: intl.formatMessage({ id: 'common.product_information' }),
      value: informationHeader?.current?.parentNode.parentNode.parentNode,
    });
  }

  if (accordionEl && accordionEl.length > 0) {
    quickList.push({
      label: intl.formatMessage({ id: 'common.product_specifications' }),
      value: specificationsHeader.current,
    });
  }

  const productOffers = getSortedProductOffersList();
  const propertyColors = getPropertyColorsFromProduct(productInfo?.id);
  const propertySizes = getPropertySizesFromProduct(size);

  const truncatedDescription = productInfo.shortDesc
    ? productInfo.shortDesc.substring(0, 157) + '...'
    : `${productInfo.campaign} - ${productInfo.name}`;
  const truncatedDescriptionOfTop = productInfo.shortDesc ? productInfo.shortDesc.substring(0, 350) + '...' : '';

  let discountOnTitle = '';
  if (productInfo.discount) {
    const discountTitle = Math.round(productInfo.discount_pct);
    discountOnTitle =
      process.env.REACT_APP_FONT_SUBSET === 'ae'
        ? ` - with ${discountTitle}% discount`
        : ` - met ${discountTitle}% korting`;
  }

  const arrayOfName = productInfo.name
    .toLowerCase()
    .replace('/', ' ')
    .split(' ');

  let isColorPresentInName = null;

  productInfo.color &&
    productInfo.color.forEach((item) => {
      isColorPresentInName = arrayOfName.includes(item);
    });

  let colorsOfProduct = '';

  if (productInfo?.color?.length > 0 && !isColorPresentInName) {
    colorsOfProduct = ` - ${productInfo.color.join(',')}`;
  }

  const titleOfProduct = `${productInfo?.name.trim()}${colorsOfProduct}${discountOnTitle}`;
  const urlSafeText = productInfo.brand && productInfo.brand.replace('&', '%26');
  //todo: get meta data from api
  const customDesc = `${titleOfProduct} - ${productInfo.campaign} ${
    titleOfProduct.length + productInfo.campaign.length < 100 ? '- ' + config.head.description : ''
  }`;
  //todo: Finish chart appearance and UX for multiple lines
  //For this product chart with multiple lines will be shown
  // const theChosenOne = productId === '8c0069ba8dfc02fde18d0e5966e2c53d';
  // const offers =
  //   (!theChosenOne && [{ shopName: productInfo.campaign, id: productId }]) ||
  //   productOffers.map((shop) => ({ shopName: shop.campaign, id: shop.id }));
  let productDescriptionNode = '';
  try {
    productDescriptionNode = parse(productInfo?.description || '');
  } catch (e) {
    console.error(e);
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href={`${config.baseUrl}${productInfo?.canonical_path}`} />
        <title>{clipTextEllipsis(titleOfProduct, 60)}</title>
        <meta name="twitter:title" content={clipTextEllipsis(productInfo?.name, 70)} />
        <meta property="og:title" content={clipTextEllipsis(productInfo?.name, 50)} />
        <meta property="og:url" content={`${config.baseUrl}${productInfo?.canonical_path}`} />
        <meta data-react-helmet="true" property="og:image:height" content="300" />
        <meta data-react-helmet="true" property="og:image:width" content="300" />
        <meta property="og:image" content={`${getCDNImage(productInfo.images[0])}`} />
        <meta name="twitter:image" content={`${getCDNImage(productInfo.images[0])}`} />
      </Helmet>
      {productInfo?.shortDesc ? (
        <Helmet>
          <meta name="description" content={truncatedDescription} />
          <meta name="twitter:description" content={clipTextEllipsis(truncatedDescription, 200)} />
          <meta property="og:description" content={clipTextEllipsis(truncatedDescription, 160)} />
        </Helmet>
      ) : (
        <Helmet>
          <meta name="description" content={customDesc} />
          <meta name="twitter:description" content={clipTextEllipsis(customDesc, 200)} />
          <meta property="og:description" content={clipTextEllipsis(customDesc, 160)} />
        </Helmet>
      )}
      {isExpiredProduct && (
        <Helmet>
          <meta name="miab:type" content="epdp" />
        </Helmet>
      )}
      <StickyHeader />
      <div className={styles.wrapper}>
        <main className={classNames(styles.root, 'container')} id="readyForCrawler">
          <div className={classNames(styles.container, 'row')}>
            <Breadcrumb classList={{ root: styles.breadcrumb }} items={breadcrumbList} />
            <ProductSchema productInfo={productInfo} reviewsInfo={productReviews} />
            <div className={classNames(styles.contentWrap, 'row col-12-xs')}>
              <div className={classNames(styles.galleryContent, 'col-12-xs col-6-xl')}>
                {(!productInfo?.adult || !!adultContentAllowed) && <Gallery images={images.slice(0, 4)} />}
                {!!productInfo?.adult && !adultContentAllowed && (
                  <AdultContent width={80} height={80} viewBox="0 0 16 16" className={styles.adultContentPic} />
                )}
              </div>
              <div className={classNames('col-12-xs offset-6-xl col-6-xl')}>
                <div
                  data-testid="ProductDetailsPageProductDescription"
                  className={classNames(styles.description, {
                    [styles.small]: description.current && description.current.clientHeight < 258,
                  })}
                  style={{
                    height: height,
                  }}
                >
                  <p className={classNames(styles.brandText, { [styles.brandTextFlexEnd]: !productInfo.brand })}>
                    {productInfo.brand && (
                      <span>
                        <FormattedMessage id="common.more" defaultMessage="More" />{' '}
                        <Link to={`${getPagePath(ARD_SEARCH)}?brand=${urlSafeText}`}>{productInfo.brand}</Link>
                        {productInfo.category && (
                          <>
                            <br />
                            <FormattedMessage id="common.more" defaultMessage="More" />{' '}
                            {/* todo: possible issue with products with no subcategory */}
                            <Link to={`${getPagePath(ARD_SEARCH, categories)}?brand=${urlSafeText}`}>
                              {productInfo.brand} <FormattedMessage id="common.in" defaultMessage="in" />{' '}
                              {categoriesNames[categoriesNames.length - 1]}
                            </Link>
                          </>
                        )}
                      </span>
                    )}
                    <span className={styles.actionBtns}>
                      {likedProduct && (
                        <FormattedMessage id="profile.wishlistRemove" defaultMessage="Remove from wishlist">
                          {(label) => (
                            <button aria-label={label} className={styles.wishlistBtn} onClick={handleWishlistBtnPress}>
                              <WishListSelectedIcon className={styles.likedProductIcon} />
                            </button>
                          )}
                        </FormattedMessage>
                      )}
                      {!likedProduct && (
                        <FormattedMessage id="profile.wishlistAdd" defaultMessage="Add to wishlist">
                          {(label) => (
                            <button aria-label={label} className={styles.wishlistBtn} onClick={handleWishlistBtnPress}>
                              <WishListIcon />
                            </button>
                          )}
                        </FormattedMessage>
                      )}
                    </span>
                  </p>
                  <h1 className={classNames({ [styles.blurAdult]: !!productInfo?.adult && !adultContentAllowed })}>
                    <b>{productInfo.name}</b>
                  </h1>
                  {/* <div className={styles.productRating}>
                    <Rating value={productInfo?.reviews?.rating?.total_rating} />
                    <span>({productInfo?.reviews?.rating?.number_of_ratings || 0})</span>
                  </div> */}
                  <ReviewStats
                    ratingValue={productInfo?.reviews?.rating?.total_rating}
                    reviewsCount={productInfo?.reviews?.rating?.number_of_ratings}
                  />
                  <div
                    ref={description}
                    className={classNames(
                      { [styles.blurAdult]: !!productInfo?.adult && !adultContentAllowed },
                      styles.productDescriptionContent
                    )}
                  >
                    {truncatedDescriptionOfTop || ''}
                  </div>
                </div>
                {description.current && (
                  <button className={styles.readMoreBtn} onClick={() => moveToProductMoreInfo()}>
                    <FormattedMessage id="shop.readMore" defaultMessage="Read more" />
                    <ArrowDownIcon className={styles.arrowDownIcon} />
                  </button>
                )}
                <div className={styles.quickLinks}>
                  <p className={styles.quickBold}>
                    <FormattedMessage id="shop.quick" defaultMessage="Quick to" />
                  </p>
                  <div className={styles.dropdown} onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                    <ul className={styles.dropdownUl}>
                      <li>
                        {intl.formatMessage({ id: 'shop.prices' })} <ArrowDownIcon />
                      </li>
                      <ul className={classNames(styles.dropdownUlUl, { [styles.isOpen]: isDropdownOpen })}>
                        {isDropdownOpen &&
                          quickList.map((item, index) => {
                            return (
                              <li
                                data-value={item.label}
                                tabIndex="0"
                                key={`${item.label}-${index}`}
                                className={classNames(styles.dropdownItem, { [styles.selected]: 0 === index })}
                                onClick={() => scrollToElement(item.value)}
                              >
                                {item.label}
                              </li>
                            );
                          })}
                      </ul>
                    </ul>
                  </div>
                  <div className={styles.linksDesktop}>
                    <p>
                      <span onClick={() => scrollToElement(pricesHeaderRef.current)}>
                        <FormattedMessage id="shop.prices" defaultMessage="Prices" />
                      </span>
                      {productInfo?.description && (
                        <span
                          onClick={() => scrollToElement(descriptionHeader.current.parentNode.parentNode.parentNode)}
                        >
                          <FormattedMessage id="common.product_description" defaultMessage="Product Description" />
                        </span>
                      )}
                      {productInformation.current && (
                        <span
                          onClick={() => scrollToElement(informationHeader.current?.parentNode.parentNode.parentNode)}
                        >
                          <FormattedMessage id="common.product_information" defaultMessage="Product Information" />
                        </span>
                      )}
                      {accordionEl && accordionEl.length > 0 && (
                        <span onClick={() => scrollToElement(specificationsHeader.current)}>
                          <FormattedMessage
                            id="common.product_specifications"
                            defaultMessage="Product Specifications"
                          />
                        </span>
                      )}
                    </p>
                  </div>
                </div>
                <div className="offset-6-xl col-6-xl">
                  {propertyColors.components && propertyColors.components.length > 1 && (
                    <div className={styles.propertyWrapper}>
                      <span>
                        <FormattedMessage id="product.color" defaultMessage="Color: " />
                        {propertyColors?.colorSelected?.color}
                      </span>
                      <PropertyCarousel
                        components={propertyColors.components}
                        selectedIndex={propertyColors.selectedIndex}
                        colors
                      />
                    </div>
                  )}
                  {propertySizes.components && propertySizes.components.length > 0 && (
                    <div className={styles.propertyWrapper}>
                      <FormattedMessage id="product.chooseSize" defaultMessage="Choose a size" />
                      <PropertyCarousel
                        components={propertySizes.components}
                        selectedIndex={propertySizes.selectedIndex}
                        sizes
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <span
            className={classNames(styles.footerMobile, 'col-12-xs', {
              [styles.inVisible]: visible,
            })}
            ref={buttonMobile}
          >
            <Button
              classList={{ root: styles.buttonFooterMobile }}
              small
              variation={SECONDARY}
              onClick={() => showPage()}
            >
              <ShopListMobile />
              <span className={classNames(styles.buttonWrapp)}>
                <FormattedMessage id="shop.viewPrices" defaultMessage="View prices" />
              </span>
            </Button>
          </span>
        </main>
      </div>
      <ProductOffers
        pricesHeaderRef={pricesHeaderRef}
        isExpiredProduct={isExpiredProduct}
        activeShopsSortOrder={activeShopsSortOrder}
        availableSortOptions={availableSortOptions}
        changeSortOrder={changeSortOrder}
        offersList={productOffers}
        clickout={clickout}
        size={size}
        shopInfoData={shopInfoData}
      />
      <div className="container">
        <div className="col-12-xs">
          <SimilarProductsSection
            products={similarProducts}
            classList={{ root: styles.similarProducts, title: styles.sectionTitle }}
          />
        </div>
      </div>
      <div className="container">
        {productReviews && (
          <ReviewsComponent
            profile={profile}
            openLoginModal={showOverlay}
            formId={`review${productInfo?.id}`}
            headerRenderer={() => (
              <>
                <span>
                  <FormattedMessage id="reviews.reviews" defaultMessage="Customer reviews" />{' '}
                </span>
                <FormattedMessage id="pagination.from" defaultMessage="from" /> {productInfo.name}
              </>
            )}
            averageRating={productReviews?.rating?.total_rating || 0}
            ratingCount={productReviews?.rating?.number_of_ratings || 0}
            ratingMessageRenderer={(rating) => (
              <>
                {!rating && <FormattedMessage id="reviews.noReviews" defaultMessage="There are no reviews yet" />}
                {!!rating && (
                  <>
                    {rating} <FormattedMessage id="reviews.reviews" defaultMessage="Customer reviews" />{' '}
                  </>
                )}
              </>
            )}
            ratingCountsByScore={productReviews?.rating?.ratings}
            comments={productReviews?.reviews}
            addReviewRequest={addReviewRequest}
            reverseContent
            isEmptyState
          />
        )}
      </div>

      <span className={classNames(styles.showDesktop)}>
        <div className={classNames(styles.upsBlock)} ref={productMoreInfo}>
          <div className="container">
            <div className={classNames(styles.descriptionContainer, 'row')}>
              <h2 className={classNames('col-12-xs', styles.nameUpsBlock)}>
                <span>
                  <FormattedMessage id="common.more_about" defaultMessage="More about" />
                </span>{' '}
                {productInfo.name}
              </h2>
              <div
                ref={descriptionContainer}
                className={classNames(styles.descriptionContainerNotOpen, 'row col-12-xs', {
                  [styles.descriptionContainerOpen]: hasReadMore && openReadMore,
                })}
              >
                {hasReadMore && !openReadMore && (
                  <div className={styles.readMore}>
                    <p onClick={toggleContent}>
                      <FormattedMessage id="shop.readMore" defaultMessage="Read more" />
                    </p>
                    <ArrowDownIcon onClick={toggleContent} />
                  </div>
                )}
                {productInfo?.description && (
                  <div className={classNames('col-12-xs col-6-xl')}>
                    <div className={classNames(styles.productDescription)} style={styleProductDescription}>
                      <h3 ref={descriptionHeader}>
                        <FormattedMessage id="common.product_description" defaultMessage="Product description" />
                      </h3>
                      <div ref={productDescription}>{productDescriptionNode}</div>
                    </div>
                  </div>
                )}
                {productInformation.current &&
                  productInformation.current.clientHeight >= minAllowableHeight &&
                  !productInfo?.description &&
                  isGreaterOrEqualTo(BREAKPOINTS.EXTRA_LARGE) && (
                    <div className={classNames(styles.reasons, 'col-12-xs col-6-xl')}>
                      <h3 ref={informationHeader}>
                        <FormattedMessage id="common.product_information" defaultMessage="Product information" />
                      </h3>
                      <NoContent />
                    </div>
                  )}

                {reasonsToBuy && (
                  <div className={classNames('col-12-xs col-6-xl')}>
                    <div className={classNames(styles.reasons)} style={styleProductInformation}>
                      <h3 ref={informationHeader}>
                        <FormattedMessage id="common.product_information" defaultMessage="Product information" />
                      </h3>
                      <div ref={productInformation}>{reasonsToBuyEl}</div>
                    </div>
                  </div>
                )}
              </div>
              {accordionEl && accordionEl.length > 0 && (
                <div className={classNames(styles.accordionCont, 'col-12-xs')} ref={accordionCont}>
                  <h3 ref={specificationsHeader}>
                    <FormattedMessage id="common.product_specifications" defaultMessage="Product specifications" />
                  </h3>
                  {accordionEl}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* {isServer ? <div data-testid="chart-placeholder">chart-placeholder</div> : <PricesChart offers={offers} />} */}
        <RelatedCategories items={breadcrumbList} />
        <RecentlyViewedProducts />
        <NewsletterSection />
        <Footer />
        <LoginModal isOpen={openOverlay} setOpen={setOpenOverlay} preserveLoginInitURL />
      </span>
      <AdultContentModal isOpen={productInfo?.adult && !adultContentAllowed} />
    </>
  );
};

ProductDetailPage.displayName = 'ProductDetailPage';

const mapStateToProps = ({ config, profile, clickout }) => ({
  config,
  profile,
  clickout,
});

export default connect(mapStateToProps)(ProductDetailPage);
